import { ServiceCard } from '@/types'

/**
 * Service offerings for plumbing companies
 */
export const services: ServiceCard[] = [
  {
    id: 'service-1',
    title: 'Plumbing Website Design',
    description: 'Custom-designed websites built specifically for plumbing businesses to attract and convert local customers.',
    bulletPoints: [
      'Modern, professional design',
      'Mobile-optimized and responsive',
      'Fast loading speeds',
      'Brand-focused customization',
    ],
    icon: 'DesignServices',
  },
  {
    id: 'service-2',
    title: 'Local SEO Setup',
    description: 'Get found by local customers searching for plumbing services in your area with proven SEO strategies.',
    bulletPoints: [
      'Google Business Profile optimization',
      'Local keyword targeting',
      'Location-specific pages',
      'Structured data implementation',
    ],
    icon: 'Search',
  },
  {
    id: 'service-3',
    title: 'Lead Generation Optimization',
    description: 'Turn website visitors into paying customers with conversion-focused design and strategic CTAs.',
    bulletPoints: [
      'Clear call-to-action buttons',
      'Contact forms that convert',
      'Click-to-call functionality',
      'Trust signals and testimonials',
    ],
    icon: 'TrendingUp',
  },
  {
    id: 'service-4',
    title: 'Website Maintenance & Support',
    description: 'Keep your site running smoothly with ongoing updates, security, and support whenever you need it.',
    bulletPoints: [
      'Regular software updates',
      'Security monitoring',
      'Daily backups',
      'Ongoing technical support',
    ],
    icon: 'Build',
  },
]
